import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const AddMember = (props) => (<Svg {...props}>
    <Path d="M24.167 12.167H23V11a1.167 1.167 0 1 0-2.333 0v1.167H19.5a1.167 1.167 0 1 0 0 2.333h1.167v1.167a1.167 1.167 0 1 0 2.333 0V14.5h1.167a1.167 1.167 0 1 0 0-2.333Zm-8.984 2.006a5.741 5.741 0 0 0 1.984-4.34 5.833 5.833 0 0 0-11.667 0 5.74 5.74 0 0 0 1.983 4.34A9.334 9.334 0 0 0 2 22.667a1.167 1.167 0 0 0 2.333 0 7 7 0 0 1 14 0 1.167 1.167 0 0 0 2.334 0 9.333 9.333 0 0 0-5.484-8.494Zm-3.85-.84a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z" fill="#fff"/>
  </Svg>);
export default AddMember;
